<!--
 * @Author: zhangzhitao
 * @Date: 2019-10-22 09:35:42
 * @LastEditors  : zhangzhitao
 * @LastEditTime : 2020-01-10 16:03:44
 * @Description:
 -->
<template>
  <el-select
    class="lang-select"
    v-model="language"
    :class="{dark: dark}"
    :style="fontColor"
    v-show="list.length > 1"
  >
    <el-option
      v-for="lang in list"
      :key="lang.lang"
      :label="lang.displayName"
      :value="lang.lang"
    ></el-option>
  </el-select>
</template>

<script>
import Api from 'api/api'
import { ErrorHandleMixin } from 'utils/mixin'
import i18nUtil from 'utils/i18n'
import utils from '@/utils/util'
export default {
  name: 'language-select',
  props: {
    value: String,
    dark: {
      type: Boolean,
      default: false
    },
    fontColor: Object
  },
  data () {
    return {
      language: '',
      list: []
    }
  },
  methods: {
    _getLanguages () {
      Api.login.getLanguage().then(res => {
        this.list = res.data.languages
        let _local = this.$storage.get('portal_language')
        // 如果本地缓存的语言在支持的语言列表中，使用这个语言
        this.list.forEach(item => {
          if (item.lang === _local) {
            this.language = item.lang
          }
        })
        // 如果没有则使用返回的默认语言
        if (this.language === '') {
         // this.language = res.data.default
          this.language = utils.browserLangMap()
        }
      }).catch(this._handleError)
    }
  },
  watch: {
    language (value) {
      this.$emit('input', value)
      i18nUtil.setLanguage(value)
      this.$storage.set('portal_language', value)
    },
    fontColor () {
      let dom = document.getElementsByClassName('lang-select')[0].getElementsByClassName('el-input__inner')[0]
      dom.style.color = this.fontColor.color
    }
  },
  mounted () {
    // 根据父节点传入的值赋值
    if (this.value && this.value !== '') {
      this.language = this.value
    }
    this._getLanguages()
  },
  mixins: [ErrorHandleMixin]
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.lang-select {
  width: 168px;
  margin-left: 22px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 2px;
  &:hover{
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  /deep/ .el-input__inner{
    height:30px;
  }
}
</style>
